import { ResourceOptions } from 'react-admin';
import { MdOutlineSystemUpdate } from 'react-icons/md';
import { Resources } from '../resource';
import './init';

export { default as list } from './List';
export { default as create } from './Create';
export { default as edit } from './Edit';

export const name = Resources.appVersionManagement;
export const icon = MdOutlineSystemUpdate;
export const options: ResourceOptions = {
  label: 'resource.appVersionManagement',
};
